module.exports = __webpack_public_path__ + "img/510-bd75b3.png";